<script setup lang="ts"></script>

<template>
  <div class="flex gap-x-4 items-start">
    <dt
      class="text-neutral-500 text-sm font-normal flex"
      :class="{ 'flex-col': $slots.subtitle }"
    >
      <slot name="title"></slot>
      <slot name="subtitle"></slot>
    </dt>
    <div class="flex-grow flex justify-between">
      <dd class="flex text-neutral-950 text-sm font-normal">
        <slot name="description"></slot>
      </dd>
      <dd v-if="$slots.extra">
        <slot name="extra"></slot>
      </dd>
    </div>
  </div>
</template>
